import "UI/Widget/Form";
/** @namespace UI.Widget.Forms */
NS("UI.Widget.Forms");

/**
 * @class
 * @extends UI.Widget.Form
 */
UI.Widget.Forms.ViewForm = Class(UI.Widget.Form, {
    formTemplate: "UI/Widget/Forms/ViewForm/ViewForm",
    columnTemplates: "UI/Widget/Forms/ViewForm/Column/",

    draggable: false,

    columns: [],

    item: null,

    destroy: function() {
        this.item = null;

        return this.ParentCall();
    },

    columnContent: function(column) {
        if (!column.type) {
            column.type = "Text";
        }

        switch (column.type) {
            case "template":
                return UI.Template.render(column.template, {
                    widget: this,
                    column: column
                });
            case "callback":
                return column.callback.call(this, this.item, column);
            default:
                return UI.Template.render(this.columnTemplates + column.type, {
                    widget: this,
                    column: column,
                    item: this.item
                });
        }
    }
});
